import { createSelector } from 'reselect';

export const getAvailableDatabaseOptions = state => state.availableDatabaseOptions;
export const getConnectableObjects = state => state.connectableObjects;
export const getProject = state => state.project;
export const getTasks = state => state.tasks;

export const getAssigneeOptions = createSelector(
  [getProject],
  project => [...project.collaborators, ...project.otherAuthorizedUsers]
);

